import { Alert } from "@mui/material";
import HelpArticleLink from "@entrilia/shared/components/HelpArticleLink";
import { intercomArticleIds } from "@entrilia/shared/utilities/intercomArticles";

interface Props {
  text: string;
}

const CustomNumberFormatsAlert = ({ text }: Props) => {
  return (
    <Alert severity="info" sx={{ whiteSpace: "pre-line" }}>
      {text}{" "}
      <HelpArticleLink articleId={intercomArticleIds.CUSTOM_NUMBER_FORMAT_LIMITATION} underline="always">
        Learn more
      </HelpArticleLink>
    </Alert>
  );
};

export default CustomNumberFormatsAlert;
